import { NgModule } from '@angular/core';
import { AccredibleSvgProcessorService } from './svg-processor.service';

@NgModule({
  providers: [AccredibleSvgProcessorService],
})
export class AccredibleSvgProcessorServiceModule {}
